<template>
  <div class="main">
    <!-- Panel de personalización -->
    <div class="customizer-panel">
      <h2>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="19.5" cy="12.5" r="2.5"></circle>
          <path d="M19.5 9v-4"></path>
          <path d="M19.5 16v4"></path>
          <circle cx="4.5" cy="4.5" r="2.5"></circle>
          <path d="M4.5 7v13"></path>
          <circle cx="12" cy="18.5" r="2.5"></circle>
          <path d="M12 16V4"></path>
        </svg>
        Personaliza tu factura
      </h2>

      <!-- Carga de logo -->
      <div class="mb-6">
        <h3>Logo de empresa</h3>
        <div class="logo-container">
          <div class="logo-preview" ref="logoPreview">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"
              stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"></path>
              <circle cx="12" cy="13" r="3"></circle>
            </svg>
          </div>
          <div class="logo-upload">
            <label for="logo-upload" class="upload-btn">Subir logotipo</label>
            <input id="logo-upload" type="file" accept="image/*" @change="handleLogoUpload" style="display: none" />
            <p class="upload-info">Formatos: PNG, JPG, SVG. Máx. 2MB</p>
          </div>
        </div>
        <div class="logo-size">
          <label for="logo-size-input">Tamaño del logo</label>
          <div class="range-container">
            <input id="logo-size-input" type="range" min="80" max="200" v-model.number="logoSize" />
            <span class="range-value">{{ logoSize }}px</span>
          </div>
        </div>
      </div>

      <!-- Configuración de colores -->
      <div class="mb-6">
        <h3>Colores de la factura</h3>
        <div class="color-grid">
          <div class="color-input">
            <label>Color principal</label>
            <div class="color-picker">
              <input type="color" v-model="primaryColor" />
              <input type="text" v-model="primaryColor" />
            </div>
          </div>
          <div class="color-input">
            <label>Color secundario</label>
            <div class="color-picker">
              <input type="color" v-model="secondaryColor" />
              <input type="text" v-model="secondaryColor" />
            </div>
          </div>
          <div class="color-input">
            <label>Color de acento (botón de pago)</label>
            <div class="color-picker">
              <input type="color" v-model="accentColor" />
              <input type="text" v-model="accentColor" />
            </div>
          </div>
          <div class="color-input">
            <label>Color del texto en encabezado</label>
            <div class="color-picker">
              <input type="color" v-model="textColor" />
              <input type="text" v-model="textColor" />
            </div>
            <div class="color-preview">
              <div class="preview-box" :style="{ backgroundColor: primaryColor, color: textColor }">
                Vista previa
              </div>
              <div class="contrast-warning" v-if="contrastWarning">{{ contrastWarning }}</div>
            </div>
          </div>
        </div>

        <!-- Esquemas predefinidos -->
        <div>
          <h4>Esquemas predefinidos</h4>
          <div class="color-schemes">
            <button v-for="(scheme, index) in colorSchemes" :key="index" class="scheme-btn" @click="applyScheme(scheme)">
              <div class="scheme-colors">
                <div class="scheme-color" :style="{ backgroundColor: scheme.primary }"></div>
                <div class="scheme-color" :style="{ backgroundColor: scheme.secondary }"></div>
              </div>
              {{ scheme.name }}
            </button>
          </div>
        </div>
      </div>

      <!-- Información de Pago -->
      <div class="mb-6">
        <h3>Información de Pago</h3>
        <div class="color-grid">
          <div class="color-input">
            <label>Banco</label>
            <div class="color-picker">
              <input type="text" v-model="bank" />
            </div>
          </div>
          <div class="color-input">
            <label>Titular</label>
            <div class="color-picker">
              <input type="text" v-model="holder" />
            </div>
          </div>
          <div class="color-input">
            <label>Cuenta Colones</label>
            <div class="color-picker">
              <input type="text" v-model="accountCRC" />
            </div>
          </div>
          <div class="color-input">
            <label>Cuenta Dólares</label>
            <div class="color-picker">
              <input type="text" v-model="accountUSD" />
            </div>
          </div>
          <div class="color-input">
            <label>IBAN Colones</label>
            <div class="color-picker">
              <input type="text" v-model="ibanCRC" />
            </div>
          </div>
          <div class="color-input">
            <label>IBAN Dólares</label>
            <div class="color-picker">
              <input type="text" v-model="ibanUSD" />
            </div>
          </div>
        </div>
      </div>

      <!-- Botones de acción -->
      <div class="actions">
        <button class="btn btn-primary" v-if="false" @click="showPreview">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
          </svg>
          Vista previa de factura
        </button>
        <button :disabled="saving" class="btn btn-secondary" @click="resetToDefault">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21.5 2v6h-6"></path>
            <path d="M2.5 12a10 10 0 0 1 19-3l-1 1"></path>
            <path d="M2.5 22v-6h6"></path>
            <path d="M21.5 12a10 10 0 0 1-19 3l1-1"></path>
          </svg>
          Restaurar valores predeterminados
        </button>
        <button class="btn btn-success" @click="saveSettings" v-if="!saving">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
            <polyline points="17 21 17 13 7 13 7 21"></polyline>
            <polyline points="7 3 7 8 15 8"></polyline>
          </svg>
          Guardar configuración
        </button>
        <button class="btn btn-success" style="cursor: default;" v-else>
          <v-progress-circular
            :width="3"
            :size="24"
            color="white"
            indeterminate
          ></v-progress-circular>
        </button>
      </div>
    </div>

    <!-- Previsualización -->
    <div v-show="isPreviewVisible" class="preview-panel">
      <div class="preview-header">
        <h2>Vista previa de la factura</h2>
        <button class="back-btn" v-if="false" @click="hidePreview">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
          Volver a editar
        </button>
      </div>
      <div class="preview-content">
        <div class="invoice-preview">
          <div class="invoice">
            <div class="invoice-header" :style="{
              background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
              color: textColor
            }">
              <h1 class="invoice-title">Factura Electrónica</h1>
              <div class="invoice-serial">
                1 de abril de 2025 18:15<br />00100001010000000955
              </div>
            </div>
            <div class="invoice-info">
              <div class="company-info">
                <h2 :style="{ color: primaryColor }">{{ getCompany.tradename || getCompany.tradename }}</h2>
                <p v-if="getCompany.tradename">{{ getCompany.name | capitalizeWords }}</p>
                <p><strong>Cédula Jurídica:</strong> {{ getCompany.identification }} | <strong>Teléfono:</strong> (+506) {{ getCompany.phone }}</p>
                <p><strong>Email:</strong> {{ getCompany.email }}</p>
                <p><strong>Dirección:</strong> Sabanilla, Montes de Oca, San José - 300m sur del mas x menos</p>
                <p class="system-info"><em>Emitido por: José Daniel Pérez Castañeda</em></p>
              </div>
              <div class="logo-container-invoice" ref="invoiceLogo"
                :style="{ width: logoSize + 'px', height: logoSize + 'px' }">
                <span v-if="!logoUrl">Tu logo aquí</span>
                <img v-else :src="logoUrl" alt="Logo Empresa" style="width: 100%; height: auto" />
              </div>
            </div>
            <!-- Datos del cliente -->
            <div class="client-info">
              <div>
                <h3 :style="{ color: primaryColor }">Cliente:</h3>
                <div class="client-name">P&G</div>
                <p>PROCTER & GAMBLE INTERNATIONAL OPERATIONS S.A</p>
                <p><strong>Cédula Jurídica:</strong> 3012624563 | <strong>Teléfono:</strong> (+506) 2204100</p>
                <p><strong>Dirección:</strong> Forum1, Pozos de Santa Ana, Edificio A-B-C, 10903</p>
              </div>
              <div class="payment-info">
                <p><strong>Moneda:</strong> USD($) <em>Cambio ₡ 504.07</em></p>
                <p><strong>Medio Pago:</strong> Transferencia bancaria</p>
                <p><strong>Cond. Venta:</strong> Crédito</p>
                <p><strong>Plazo Crédito:</strong> 75 días</p>
              </div>
            </div>
            <!-- Detalle de productos -->
            <div class="invoice-details">
              <h3>Detalle</h3>
              <table class="items-table">
                <thead>
                  <tr :style="{ backgroundColor: primaryColor, color: textColor }">
                    <th style="width: 40%">Descripción</th>
                    <th style="width: 8%">Unid</th>
                    <th style="width: 8%">Cant</th>
                    <th style="width: 10%">Precio</th>
                    <th style="width: 10%">Subtotal</th>
                    <th style="width: 8%">Desc.</th>
                    <th style="width: 8%">Imp.</th>
                    <th style="width: 8%">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, i) in invoiceItems" :key="i"
                    :style="{ backgroundColor: i % 2 === 1 ? '#f9f9f9' : 'transparent' }">
                    <td>{{ item.description }}</td>
                    <td>{{ item.unit }}</td>
                    <td>{{ item.qty }}</td>
                    <td>{{ item.price }}</td>
                    <td>{{ item.subtotal }}</td>
                    <td>{{ item.discount }}</td>
                    <td>{{ item.tax }}</td>
                    <td>{{ item.total }}</td>
                  </tr>
                </tbody>
              </table>
              <!-- Totales -->
              <div class="totals">
                <div class="total-row">
                  <span>Subtotal</span>
                  <span>$ 1,550</span>
                </div>
                <div class="total-row">
                  <span>Exento</span>
                  <span>$ 0</span>
                </div>
                <div class="total-row">
                  <span>Impuesto</span>
                  <span>$ 0</span>
                </div>
                <div class="total-row">
                  <span>Exonerado</span>
                  <span>$ 1,550</span>
                </div>
                <div class="total-row">
                  <span>Descuento</span>
                  <span>$ 0</span>
                </div>
                <div class="grand-total" :style="{ borderTopColor: primaryColor, color: primaryColor }">
                  <span>Total</span>
                  <span>$ 1,550</span>
                </div>
              </div>
              <p class="tax-note">*:Exoneración Aplicada</p>
            </div>
            <!-- Sección QR y botón de pago -->
            <div class="footer-section">
              <div class="qr-section">
                <div class="qr-code">
                  <span>Código QR</span>
                </div>
                <div class="qr-info">
                  <p><strong>Clave:</strong> Serial:2047</p>
                  <p><strong>Serial Ref:</strong> 1</p>
                  <p class="qr-key"><strong>Clave numérica:</strong> 50601052500011476009400101000010000000095158700508</p>
                  <div class="invoice-note">
                    <p><strong>Nota:</strong> PO: 8005835256 / /Grettel Acuña / Kristel Montes</p>
                  </div>
                </div>
              </div>
              <div>
                <div class="bank-info"  v-if="accountCRC || accountUSD || ibanCRC || ibanUSD">
                    <h4>Información de Pago</h4>
                    <p v-if="bank"><strong>Banco:</strong> {{bank}}</p>
                    <p v-if="holder"><strong>Titular:</strong> {{holder}}</p>
                    <p v-if="accountCRC"><strong>Cuenta Colones:</strong> {{accountCRC}}</p>
                    <p v-if="accountUSD"><strong>Cuenta Dólares:</strong> {{accountUSD}}</p>
                    <p v-if="ibanCRC"><strong>IBAN Colones:</strong> {{ibanCRC}}</p>
                    <p v-if="ibanUSD"><strong>IBAN Dólares:</strong> {{ibanUSD}}</p>
                </div>
                <div class="payment-buttons">
                  <button class="pay-button" :style="{ backgroundColor: accentColor, color: textColor }">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round">
                      <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
                      <line x1="1" y1="10" x2="23" y2="10"></line>
                    </svg>
                    Pagar en línea
                  </button>
                </div>
              </div>
            </div>
            <!-- Pie de página -->
            <div class="invoice-footer">
              <p>Dirección General de Tributación. Autorizada mediante resolución N° DGT-R-033-20198:05, 20 de Junio del
                2019</p>
              <p style="margin-top: 5px; font-size: 9px;">
                <a href="https://redabitscr.com" style="color: #666; text-decoration: none;" target="_blank">
                  Powered by <strong>redabits</strong>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions/*, mapState, mapMutations /**/ } from 'vuex'
export default {
  name: 'InvoiceCustomizer',
  data () {
    return {
      isPreviewVisible: true,
      primaryColor: this.$store.getters['company/getCompany'].invoiceCustomization?.primaryColor || '#2563eb',
      secondaryColor: this.$store.getters['company/getCompany'].invoiceCustomization?.secondaryColor || '#1d4ed8',
      accentColor: this.$store.getters['company/getCompany'].invoiceCustomization?.accentColor || '#059669',
      textColor: this.$store.getters['company/getCompany'].invoiceCustomization?.textColor || '#ffffff',
      logoSize: this.$store.getters['company/getCompany'].invoiceCustomization?.logoSize || 120,
      logoUrl: this.$store.getters['company/getCompany'].invoiceCustomization?.logoUrl || null,
      contrastWarning: '',
      colorSchemes: [
        { name: 'Azul Corporativo (Default)', primary: '#2563eb', secondary: '#1d4ed8', accent: '#059669', textColor: '#ffffff' },
        { name: 'Naranja', primary: '#f5a623', secondary: '#e67e22', accent: '#30a952', textColor: '#ffffff' },
        { name: 'Verde Eco', primary: '#10b981', secondary: '#059669', accent: '#2563eb', textColor: '#ffffff' },
        { name: 'Púrpura Elegante', primary: '#8b5cf6', secondary: '#7c3aed', accent: '#ec4899', textColor: '#ffffff' },
        { name: 'Rojo Energético', primary: '#ef4444', secondary: '#dc2626', accent: '#0ea5e9', textColor: '#ffffff' },
        { name: 'Amarillo Claro', primary: '#fde047', secondary: '#facc15', accent: '#0ea5e9', textColor: '#000000' },
        { name: 'Gris Claro', primary: '#d1d5db', secondary: '#9ca3af', accent: '#3b82f6', textColor: '#000000' }
      ],
      invoiceItems: Array.from({ length: 8 }, (_, i) => ({
        description: `Producto ejemplo ${i + 1}`,
        unit: 'Unid',
        qty: '1',
        price: `$ ${100 + i * 20}`,
        subtotal: `$ ${100 + i * 20}`,
        discount: '$ 0',
        tax: '13(-13)*%',
        total: `$ ${100 + i * 20}`
      })),
      saving: false,
      bank: this.$store.getters['company/getCompany'].invoiceCustomization?.bank || null,
      holder: this.$store.getters['company/getCompany'].invoiceCustomization?.holder || null,
      accountCRC: this.$store.getters['company/getCompany'].invoiceCustomization?.accountCRC || null,
      accountUSD: this.$store.getters['company/getCompany'].invoiceCustomization?.accountUSD || null,
      ibanCRC: this.$store.getters['company/getCompany'].invoiceCustomization?.ibanCRC || null,
      ibanUSD: this.$store.getters['company/getCompany'].invoiceCustomization?.ibanUSD || null
    }
  },
  computed: {
    ...mapGetters('company', ['getCompany'])
  },
  watch: {
    primaryColor () {
      this.checkContrast()
      this.updateInvoiceColors()
    },
    textColor () {
      this.checkContrast()
    },
    logoSize (newVal) {
      if (this.$refs.invoiceLogo) {
        this.$refs.invoiceLogo.style.width = newVal + 'px'
        this.$refs.invoiceLogo.style.height = newVal + 'px'
      }
    }
  },
  methods: {
    checkContrast () {
      const luminance = this.getLuminance(this.primaryColor)
      if (luminance < 0.5 && this.textColor === '#000000') {
        this.contrastWarning = '⚠️ Contraste bajo - considere usar texto claro'
      } else if (luminance >= 0.5 && this.textColor === '#ffffff') {
        this.contrastWarning = '⚠️ Contraste bajo - considere usar texto oscuro'
      } else {
        this.contrastWarning = ''
      }
    },
    getLuminance (hex) {
      const r = parseInt(hex.slice(1, 3), 16) / 255
      const g = parseInt(hex.slice(3, 5), 16) / 255
      const b = parseInt(hex.slice(5, 7), 16) / 255
      return 0.299 * r + 0.587 * g + 0.114 * b
    },
    updateInvoiceColors () {},
    handleLogoUpload (e) {
      const file = e.target.files[0]
      if (!file) return

      const reader = new FileReader()
      reader.onload = (ev) => {
        this.logoUrl = ev.target.result
        const img = document.createElement('img')
        img.src = ev.target.result
        img.style.maxHeight = '80%'
        img.style.maxWidth = '80%'
        img.style.objectFit = 'contain'

        this.$refs.logoPreview.innerHTML = ''
        this.$refs.logoPreview.appendChild(img)

        const invoiceImg = document.createElement('img')
        invoiceImg.src = ev.target.result
        invoiceImg.alt = 'Logo Empresa'
        invoiceImg.style.maxWidth = '100%'
        invoiceImg.style.height = 'auto'

        this.$refs.invoiceLogo.innerHTML = ''
        this.$refs.invoiceLogo.appendChild(invoiceImg)
      }
      reader.readAsDataURL(file)
    },
    setLogo (logoUrl) {
      this.logoUrl = logoUrl
      const img = document.createElement('img')
      img.src = logoUrl
      img.style.maxHeight = '80%'
      img.style.maxWidth = '80%'
      img.style.objectFit = 'contain'

      this.$refs.logoPreview.innerHTML = ''
      this.$refs.logoPreview.appendChild(img)

      const invoiceImg = document.createElement('img')
      invoiceImg.src = logoUrl
      invoiceImg.alt = 'Logo Empresa'
      invoiceImg.style.maxWidth = '100%'
      invoiceImg.style.height = 'auto'

      this.$refs.invoiceLogo.innerHTML = ''
      this.$refs.invoiceLogo.appendChild(invoiceImg)
    },
    applyScheme (scheme) {
      this.primaryColor = scheme.primary
      this.secondaryColor = scheme.secondary
      this.accentColor = scheme.accent
      this.textColor = scheme.textColor
    },
    resetToDefault () {
      this.primaryColor = '#2563eb'
      this.secondaryColor = '#1d4ed8'
      this.accentColor = '#059669'
      this.textColor = '#ffffff'
      this.logoSize = 120
      this.logoUrl = null
      this.$refs.logoPreview.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"></path>
          <circle cx="12" cy="13" r="3"></circle>
        </svg>
      `
      this.$refs.invoiceLogo.innerHTML = '<span>Tu logo aquí</span>'
    },
    showPreview () {
      this.isPreviewVisible = true
    },
    hidePreview () {
      this.isPreviewVisible = false
    },
    saveSettings () {
      this.saving = true
      const invoiceCustomization = {
        primaryColor: this.primaryColor,
        secondaryColor: this.secondaryColor,
        accentColor: this.accentColor,
        textColor: this.textColor,
        logoSize: this.logoSize,
        logoUrl: this.logoUrl,
        bank: this.bank,
        holder: this.holder,
        accountCRC: this.accountCRC,
        accountUSD: this.accountUSD,
        ibanCRC: this.ibanCRC,
        ibanUSD: this.ibanUSD
      }
      this.updateInvoiceCustomization(invoiceCustomization)
        .then(() => alert('¡Configuración guardada correctamente!'))
        .catch((e) => {
          console.error(e)
          alert('¡Error al guardadar configuración!')
        })
        .finally(() => { this.saving = false })
    },
    ...mapActions('company', ['updateInvoiceCustomization'])
  },
  mounted () {
    const logoUrl = this.$store.getters['company/getCompany'].invoiceCustomization?.logoUrl || null
    this.setLogo(logoUrl)
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

body {
  background-color: #f9fafb; /* bg-gray-50 */
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

header {
  background-color: white;
  border-bottom: 1px solid #e5e7eb; /* border-gray-200 */
  padding: 1rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05); /* shadow-sm */
}

h1 {
  font-size: 1.25rem;
  font-weight: bold;
  /* color: #1f2937; /* text-gray-800 */
}

.main {
  flex: 1;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

@media (min-width: 1024px) {
  .main {
    flex-direction: row;
  }
}

.customizer-panel {
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  overflow: auto;
  max-height: calc(100vh - 100px);
}

@media (min-width: 1024px) {
  .customizer-panel {
    width: 33.333333%;
  }
}

.preview-panel {
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  flex: 1;
}

h2 {
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
}

h2 svg {
  margin-right: 0.5rem;
}

h3 {
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #374151; /* text-gray-700 */
  font-size: 0.875rem;
}

h4 {
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151; /* text-gray-700 */
  margin-bottom: 0.5rem;
}

.mb-6 {
  margin-bottom: 1.5rem;
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.logo-preview {
  height: 5rem;
  width: 5rem;
  border: 2px dashed #d1d5db; /* border-gray-300 */
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9fafb; /* bg-gray-50 */
}

.logo-upload {
  flex: 1;
}

.upload-btn {
  background-color: #f9fafb; /* bg-gray-50 */
  color: #374151; /* text-gray-700 */
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  border: 1px solid #d1d5db; /* border-gray-300 */
  cursor: pointer;
  display: inline-block;
  font-size: 0.875rem;
}

.upload-btn:hover {
  background-color: #f3f4f6; /* bg-gray-100 */
}

.upload-info {
  font-size: 0.75rem;
  color: #6b7280; /* text-gray-500 */
  margin-top: 0.25rem;
}

.logo-size {
  margin-top: 0.75rem;
}

.logo-size label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151; /* text-gray-700 */
  margin-bottom: 0.25rem;
}

.range-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.range-container input[type="range"] {
  width: 100%;
}

.range-value {
  font-size: 0.875rem;
  font-weight: 500;
  color: #6b7280; /* text-gray-500 */
}

.color-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.color-input label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151; /* text-gray-700 */
  margin-bottom: 0.25rem;
}

.color-picker {
  display: flex;
  align-items: center;
}

.color-picker input[type="color"] {
  height: 2.5rem;
  width: 2.5rem;
  border: 0;
  border-radius: 0.25rem;
  margin-right: 0.5rem;
}

.payment-buttons {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.color-picker input[type="text"] {
  flex: 1;
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db; /* border-gray-300 */
  border-radius: 0.25rem;
  font-size: 0.875rem;
}

.color-preview {
  display: flex;
  margin-top: 0.5rem;
  align-items: center;
}

.preview-box {
  border-radius: 0.25rem;
  width: 6rem;
  padding: 0.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.5rem;
  font-size: 0.625rem;
}

.contrast-warning {
  font-size: 0.75rem;
  color: #f97316; /* text-orange-500 */
}

.color-schemes {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.scheme-btn {
  display: flex;
  align-items: center;
  border-radius: 9999px;
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  border: 1px solid #e5e7eb; /* border-gray-200 */
  background: none;
  cursor: pointer;
}

.scheme-btn:hover {
  background-color: #f9fafb; /* bg-gray-50 */
}

.scheme-colors {
  display: flex;
  align-items: center;
  margin-right: 0.25rem;
}

.scheme-color {
  height: 0.75rem;
  width: 0.75rem;
  border-radius: 9999px;
  margin-right: 0.25rem;
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1.5rem;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-weight: 500;
  cursor: pointer;
  border: none;
}

.btn-primary {
  background-color: #2563eb; /* bg-blue-600 */
  color: white;
}

.btn-primary:hover {
  background-color: #1d4ed8; /* bg-blue-700 */
}

.btn-secondary {
  border: 1px solid #d1d5db; /* border-gray-300 */
  background-color: white;
  color: #374151; /* text-gray-700 */
}

.btn-secondary:hover {
  background-color: #f9fafb; /* bg-gray-50 */
}

.btn-success {
  background-color: #16a34a; /* bg-green-600 */
  color: white;
}

.btn-success:hover {
  background-color: #15803d; /* bg-green-700 */
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #e5e7eb; /* border-gray-200 */
}

.back-btn {
  display: flex;
  align-items: center;
  color: #2563eb; /* text-blue-600 */
  font-size: 0.875rem;
  background: none;
  border: none;
  cursor: pointer;
}

.back-btn svg {
  height: 1rem;
  width: 1rem;
  margin-right: 0.25rem;
}

.bank-info {
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 10px;
  max-width: 350px;
  min-width: 300px;
}
.bank-info h4 {
    color: #f5a623;
    margin: 0 0 8px 0;
    font-size: 12px;
    font-weight: 600;
}
.bank-info p {
    margin: 3px 0;
    font-size: 10px;
    color: #333;
}
.bank-info strong {
    font-weight: 600;
}

.preview-content {
  padding: 1rem;
  display: flex;
  justify-content: center;
  overflow: auto;
  max-height: calc(100vh - 200px);
}

.invoice-preview {
  transform: scale(0.75);
  transform-origin: top;
  border: 1px solid #e5e7eb; /* border-gray-200 */
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.invoice {
  width: 21cm;
  min-height: 27.7cm;
  background: white;
}

.invoice-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
}

.invoice-title {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
}

.invoice-serial {
  background-color: #f2f2f2;
  color: #555;
  padding: 5px 10px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
}

.invoice-info {
  display: flex;
  justify-content: space-between;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.company-info h2 {
  margin: 0 0 10px 0;
  font-size: 18px;
  font-weight: 600;
}

.company-info p {
  margin: 3px 0;
  font-size: 11px;
}

.company-info .system-info {
  font-size: 9px;
  color: #666;
  margin-top: 2px;
}

.logo-container-invoice {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 130px;
}

.logo-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f8f8;
  border-radius: 4px;
}

.logo-placeholder span {
  font-size: 10px;
  color: #666;
}

.client-info {
  display: flex;
  justify-content: space-between;
  padding: 15px 20px;
  background-color: #f8f8f8;
  border-bottom: 1px solid #eee;
}

.client-info h3 {
  margin: 0 0 10px 0;
  font-size: 16px;
  font-weight: 600;
}

.client-name {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 5px;
}

.payment-info {
  background-color: #f0f0f0;
  border-radius: 4px;
  padding: 10px;
}

.invoice-details {
  padding: 8px 20px;
}

.invoice-details h3 {
  margin: 0 0 5px 0;
  font-size: 14px;
  font-weight: 500;
  color: #444;
}

.items-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 8px;
  font-size: 9px;
}

.items-table th {
  font-weight: 500;
  text-align: left;
  padding: 5px 8px;
  font-size: 9px;
}

.items-table td {
  padding: 4px 8px;
  border-bottom: 1px solid #eee;
  font-size: 9px;
}

.items-table tr:nth-child(odd) {
  background-color: #f9f9f9;
}

.totals {
  margin-left: auto;
  width: 200px;
}

.total-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  border-bottom: 1px solid #eee;
  font-size: 11px;
}

.grand-total {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-weight: 600;
  font-size: 14px;
  border-top-width: 2px;
  border-top-style: solid;
}

.tax-note {
  font-size: 9px;
  color: #777;
  margin-top: 5px;
  text-align: right;
}

.footer-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 20px;
}

.qr-sectiopan {
  display: flex;
  align-items: center;
  border-top: none;
  padding: 0;
}

.qr-code {
  width: 80px;
  height: 80px;
  background-color: #eee;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-code span {
  font-size: 8px;
}

.qr-info {
  margin-left: 15px;
}

.qr-info p {
  margin: 3px 0;
  font-size: 11px;
  color: #666;
}

.qr-info .qr-key {
  font-size: 9px;
  word-break: break-all;
  margin-top: 2px;
  max-width: 300px;
}

.invoice-note {
  margin: 5px 0;
  padding: 5px;
  background-color: #f8f8f8;
  border: 1px solid #eee;
  border-radius: 4px;
}

.invoice-note p {
  margin: 0;
  font-size: 11px;
  color: #666;
}

.pay-button {
  border: none;
  padding: 8px 12px;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  margin-top: 10px;
}

.pay-button svg {
  margin-right: 6px;
}

.invoice-footer {
  margin-top: 0;
  padding: 8px;
  text-align: center;
  font-size: 10px;
  color: #777;
  background-color: #f8f8f8;
  border-top: 1px solid #eee;
}

.hidden {
  display: none !important;
}

@media (min-width: 1024px) {
  .lg\:block {
    display: block !important;
  }

  .lg\:hidden {
    display: none !important;
  }
}

footer {
  background-color: #f9fafb; /* bg-gray-50 */
  border-top: 1px solid #e5e7eb; /* border-gray-200 */
  padding: 1rem 1.5rem;
  text-align: center;
  font-size: 0.875rem;
  color: #6b7280; /* text-gray-500 */
}
</style>
